import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import logo from "../assets/image/logo.png";


import pigment from '../assets/icons/Pigment-Removal.webp'
import haired from '../assets/icons/Hair-Reducation.webp'
import skintight from '../assets/icons/Skin-Tightening.webp'
import analy from '../assets/icons/analysers.webp'
import skinlift from '../assets/icons/Skin-Lifting.webp'
import hydra from '../assets/icons/Hydra-facial.webp'
import bodysc from '../assets/icons/Body-Sculpting.webp'
import hairgrowth from '../assets/icons/Hair-regrowth.webp'






const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);

  return (
    <header className="bg-white shadow-md fixed w-full z-[999]">
      <div className="container mx-auto px-4 py-2">
        <div className="flex justify-evenly items-center">
          {/* Navigation Links */}
          <nav className="hidden md:flex space-x-6">
            <NavLink
              exact
              to="/"
              className={({ isActive }) =>
                isActive
                  ? "text-colorPrimary"
                  : "text-gray-600 hover:text-colorPrimary"
              }
            >
              Home
            </NavLink>

            {/* Services Dropdown */}
            <div className="relative">
              <button
                onMouseEnter={() => setIsDropdownOpen(true)} // Open dropdown on hover
                className="text-gray-600 hover:text-colorPrimary flex items-center space-x-2"
              >
                <span>Services</span>
                <IoIosArrowDown className="text-gray-500" />
              </button>

              {isDropdownOpen && (
                <div
                  onMouseLeave={() => setIsDropdownOpen(false)}
                  className="absolute mt-5 w-[600px] bg-white  rounded-lg shadow-xl border border-gray-200 z-40"
                >
                  <div className="grid grid-cols-2 gap-6 p-4">
                    <div onClick={() => setIsDropdownOpen(false)}>
                      <DropdownItem
                        icon={pigment}
                        label="Pigment Removal"
                        // description="Remove pigmentation with modern technology."
                        link="/services/pigment-removal"
                        setIsMenuOpen={setIsMenuOpen}
                      />
                      <DropdownItem
                        icon={haired}
                        label="Hair Reduction"
                        // description="Permanent hair removal services."
                        link="/services/hair-reduction"
                        setIsMenuOpen={setIsMenuOpen}
                      />
                      <DropdownItem
                        icon={skintight}
                        label="Skin Tightening"
                        // description="Effective solutions for skin tightening."
                        link="/services/skin-tight"
                        setIsMenuOpen={setIsMenuOpen}
                      />
                      <DropdownItem
                        icon={analy}
                        label="Analysers"
                        // description="Advanced analyzers for skin assessments."
                        link="/services/analysers"
                        setIsMenuOpen={setIsMenuOpen}
                      />
                    </div>
                    <div onClick={() => setIsDropdownOpen(false)}>
                      <DropdownItem
                        icon={skinlift}
                        label="Skin Lifting"
                        // description="Professional skin lifting treatments."
                        link="/services/skin-lifting"
                        setIsMenuOpen={setIsMenuOpen}
                      />
                      <DropdownItem
                        icon={hydra}
                        label="HydraFacial"
                        // description="Deep cleansing and hydrating facial treatments."
                        link="/services/hydrafacial"
                        setIsMenuOpen={setIsMenuOpen}
                      />
                      <DropdownItem
                        icon={bodysc}
                        label="Body Sculpting"
                        // description="Body contouring and sculpting services."
                        link="/services/body-sculpting"
                        setIsMenuOpen={setIsMenuOpen}
                      />
                      <DropdownItem
                        icon={hairgrowth}
                        label="Hair Regrowth"
                        // description="Promote natural hair growth with advanced treatments."
                        link="/services/hair-regrowth"
                        setIsMenuOpen={setIsMenuOpen}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <NavLink
              to="/equipment"
              className={({ isActive }) =>
                isActive
                  ? "text-colorPrimary"
                  : "text-gray-600 hover:text-colorPrimary"
              }
            >
              Equipment
            </NavLink>
          </nav>

          {/* Logo */}
          <div className="flex items-center">
            <a href="/">
              <img src={logo} alt="Derma Rays Logo" className="w-52 md:w-72" />
            </a>
          </div>

          {/* Right Navigation Links */}
          <nav className="hidden md:flex space-x-6">
            <NavLink
              to="/about"
              className={({ isActive }) =>
                isActive
                  ? "text-colorPrimary"
                  : "text-gray-600 hover:text-colorPrimary"
              }
            >
              About Us
            </NavLink>

            <NavLink
              to="/contact"
              className={({ isActive }) =>
                isActive
                  ? "text-colorPrimary"
                  : "text-gray-600 hover:text-colorPrimary"
              }
            >
              Contact Us
            </NavLink>
          </nav>

          {/* Request a Quote Button */}
          <button className="hidden md:block bg-colorPrimary text-white px-4 py-2 rounded hover:bg-colorPrimary transition duration-300">
            Request A Quote
          </button>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-600 focus:outline-none"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg
              className="h-6 w-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>

        {/* Mobile Menu Dropdown */}
        {isMenuOpen && (
          <nav className="mt-4 md:hidden">
            <NavLink
              exact
              to="/"
              onClick={() => setIsMenuOpen(false)}
              className={({ isActive }) =>
                isActive
                  ? "block py-2 text-colorPrimary"
                  : "block py-2 text-gray-600 hover:text-colorPrimary"
              }
            >
              Home
            </NavLink>

            <NavLink
              to="/about"
              onClick={() => setIsMenuOpen(false)}
              className={({ isActive }) =>
                isActive
                  ? "block py-2 text-colorPrimary"
                  : "block py-2 text-gray-600 hover:text-colorPrimary"
              }
            >
              About Us
            </NavLink>

            <div className="relative">
              <button
                onClick={() => setIsMobileDropdownOpen(!isMobileDropdownOpen)}
                className="w-full text-left py-2 text-gray-600  flex items-center justify-between"
              >
                <span>Services</span>
                <IoIosArrowDown className="text-gray-500" />
              </button>
              {isMobileDropdownOpen && (
                <div className="absolute left-0 mt-2 w-full overflow-scroll bg-white rounded-lg shadow-xl border border-gray-200 z-40">
                  <div className="grid grid-cols-2 gap-4 p-4">
                    <div>
                      <DropdownItem
                        icon={pigment}
                        label="Pigment Removal"
                        link="/services/pigment-removal"
                        setIsMenuOpen={setIsMenuOpen}
                        // onClick={() => setIsMenuOpen(false)}
                      />
                      <DropdownItem
                        icon={haired}
                        label="Hair Reduction"
                        link="/services/hair-reduction"
                        setIsMenuOpen={setIsMenuOpen}
                        // onClick={() => setIsMenuOpen(false)}
                      />

                      <DropdownItem
                        icon={skintight}
                        label="Skin Tightening"
                        link="/services/skin-tight"
                        setIsMenuOpen={setIsMenuOpen}
                        // onClick={() => setIsMenuOpen(false)}
                      />
                      <DropdownItem
                        icon={analy}
                        label="Analysers"
                        link="/services/analysers"
                        setIsMenuOpen={setIsMenuOpen}
                        // onClick={() => setIsMenuOpen(false)}
                      />
                    </div>

                    <div>
                      <DropdownItem
                        icon={skinlift}
                        label="Skin Lifting"
                        link="/services/skin-lifting"
                        setIsMenuOpen={setIsMenuOpen}
                      />
                      <DropdownItem
                        icon={hydra}
                        label="HydraFacial"
                        link="/services/hydrafacial"
                        setIsMenuOpen={setIsMenuOpen}
                      />
                      <DropdownItem
                        icon={bodysc}
                        label="Body Sculpting"
                        link="/services/body-sculpting"
                        setIsMenuOpen={setIsMenuOpen}
                      />
                      <DropdownItem
                        icon={hairgrowth}
                        label="Hair Regrowth"
                        link="/services/hair-regrowth"
                        setIsMenuOpen={setIsMenuOpen}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <NavLink
              to="/equipment"
              onClick={() => setIsMenuOpen(false)}
              className={({ isActive }) =>
                isActive
                  ? "block py-2 text-colorPrimary"
                  : "block py-2 text-gray-600 hover:text-colorPrimary"
              }
            >
              Equipment
            </NavLink>

            <NavLink
              to="/contact"
              onClick={() => setIsMenuOpen(false)}
              className={({ isActive }) =>
                isActive
                  ? "block py-2 text-colorPrimary"
                  : "block py-2 text-gray-600 hover:text-colorPrimary"
              }
            >
              Contact Us
            </NavLink>

            <button className="mt-2 w-full bg-colorPrimary text-white px-4 py-2 rounded hover:bg-colorPrimary transition duration-300">
              Request A Quote
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

// Dropdown item component for the services dropdown
const DropdownItem = ({ link, icon, label, description, setIsMenuOpen }) => (
  <NavLink
    to={link}
    onClick={() => setIsMenuOpen(false)}
    className="flex justify-between items-center mb-4 hover:bg-gray-50 p-2 rounded-lg transition"
  >
    <div className="flex items-start space-x-3">
      <img src={icon} className="h-10 w-10"/>
      <div>
        <h4 className="text-gray-800 font-semibold">{label}</h4>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
    </div>
  </NavLink>
);

export default Header;
